import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VList } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(VAutocomplete, {
        staticClass: "mx-4",
        attrs: {
          label: "Filter by Customer",
          placeholder: "All customers",
          clearable: "",
          items: _vm.customers,
          "item-value": "id",
          "item-text": "name",
          "return-object": "",
        },
        on: {
          change: function ($event) {
            _vm.productFilter = null
            _vm.filter()
          },
        },
        model: {
          value: _vm.selectedCustomer,
          callback: function ($$v) {
            _vm.selectedCustomer = $$v
          },
          expression: "selectedCustomer",
        },
      }),
      _vm.isMobile
        ? _c(VAutocomplete, {
            staticClass: "mx-4",
            attrs: {
              label: "Filter by Product",
              placeholder: "All products",
              clearable: "",
              items: _vm.products,
            },
            on: {
              click: function ($event) {
                $event.preventDefault()
                $event.stopPropagation()
              },
              change: _vm.filter,
            },
            model: {
              value: _vm.productFilter,
              callback: function ($$v) {
                _vm.productFilter = $$v
              },
              expression: "productFilter",
            },
          })
        : _vm._e(),
      _vm.eventList
        ? _c(
            VDataTable,
            {
              staticClass: "inventory-details",
              attrs: {
                headers: _vm.headers,
                items: _vm.filteredEventList,
                "item-key": "name",
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "header.inventoryId",
                    fn: function ({}) {
                      return [
                        _c(VAutocomplete, {
                          attrs: {
                            label: "Product",
                            placeholder: "Filter by product",
                            "hide-details": "",
                            dense: "",
                            clearable: "",
                            items: _vm.products,
                          },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              $event.stopPropagation()
                            },
                            change: _vm.filter,
                          },
                          model: {
                            value: _vm.productFilter,
                            callback: function ($$v) {
                              _vm.productFilter = $$v
                            },
                            expression: "productFilter",
                          },
                        }),
                      ]
                    },
                  },
                  {
                    key: "item.inventoryId",
                    fn: function ({ item }) {
                      return [
                        _c(
                          "a",
                          {
                            attrs: {
                              target: "_blank",
                              href: `${_vm.backofficeUrl}/admin/inventory/${item.inventoryId}`,
                            },
                          },
                          [_vm._v(" " + _vm._s(item.product) + " ")]
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.time",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("formatDateTime")(item.time)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.quantity",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("formatNumber")(item.quantity * -1)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.salesWeightAdjustment",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm._f("formatNumber")(item.salesWeightAdjustment)
                            ) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.price",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm._f("currency")(item.price)) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.saleItemUnitPrice",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(_vm._f("currency")(item.saleItemUnitPrice)) +
                            " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.value",
                    fn: function ({ item }) {
                      return [
                        item.costAdjustment != 0
                          ? _c(
                              "div",
                              [
                                _c(
                                  VMenu,
                                  {
                                    attrs: { bottom: "", "offset-y": "" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "div",
                                                _vm._g(
                                                  _vm._b(
                                                    {},
                                                    "div",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                ),
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass: "red--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm._f("currency")(
                                                            item.value
                                                          )
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  },
                                  [
                                    _c(
                                      VList,
                                      [
                                        _c(
                                          VLayout,
                                          {
                                            staticStyle: { height: "60vh" },
                                            attrs: { column: "" },
                                          },
                                          [
                                            _c(
                                              VFlex,
                                              {
                                                staticStyle: {
                                                  overflow: "auto",
                                                },
                                              },
                                              [
                                                _c(
                                                  VSimpleTable,
                                                  { staticClass: "ma-4" },
                                                  [
                                                    _c("thead", [
                                                      _c("tr", [
                                                        _c(
                                                          "th",
                                                          {
                                                            staticClass:
                                                              "text-center",
                                                            attrs: {
                                                              colspan: "2",
                                                            },
                                                          },
                                                          [
                                                            _vm._v(
                                                              " Cost Adjustments "
                                                            ),
                                                          ]
                                                        ),
                                                      ]),
                                                      _c("tr", [
                                                        _c("th", [
                                                          _vm._v("Amount"),
                                                        ]),
                                                        _c("th", [
                                                          _vm._v("Notes"),
                                                        ]),
                                                      ]),
                                                    ]),
                                                    _c(
                                                      "tbody",
                                                      _vm._l(
                                                        _vm.getCostAdjustments(
                                                          item.inventoryId,
                                                          _vm.date
                                                        ),
                                                        function (adj, index) {
                                                          return _c(
                                                            "tr",
                                                            { key: index },
                                                            [
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm._f(
                                                                      "currency"
                                                                    )(
                                                                      adj.amount
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                              _c("td", [
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "ma-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        adj.notes
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "text-caption text-right ma-2",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " " +
                                                                        _vm._s(
                                                                          _vm._f(
                                                                            "formatDateYear"
                                                                          )(
                                                                            adj.adjustmentTime
                                                                          )
                                                                        ) +
                                                                        " "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]),
                                                            ]
                                                          )
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("currency")(item.value * -1)) +
                                  " "
                              ),
                            ]),
                      ]
                    },
                  },
                  {
                    key: "item.unitCost",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm._f("currency")(item.unitCost)) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.net",
                    fn: function ({ item }) {
                      return [
                        _vm._v(
                          " " + _vm._s(_vm._f("currency")(item.net)) + " "
                        ),
                      ]
                    },
                  },
                  {
                    key: "item.margin",
                    fn: function ({ item }) {
                      return [
                        _vm._v(" " + _vm._s(item.margin.toFixed(2)) + "% "),
                      ]
                    },
                  },
                ],
                null,
                false,
                1264772619
              ),
            },
            [
              _vm.summary
                ? _c(
                    "template",
                    { slot: _vm.isMobile ? "body.prepend" : "body.append" },
                    [
                      _vm.isMobile
                        ? _c(
                            "tr",
                            { staticClass: "v-data-table__mobile-table-row" },
                            [
                              _c(
                                "td",
                                { staticClass: "v-data-table__mobile-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__header",
                                    },
                                    [_vm._v("Total Quantity")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__cell",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            _vm.summary.quantity
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "v-data-table__mobile-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__header",
                                    },
                                    [_vm._v("Total Weight Adj.")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__cell",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatNumber")(
                                            _vm.summary.weightAdj
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "v-data-table__mobile-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__header",
                                    },
                                    [_vm._v("Total Price")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__cell",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(_vm.summary.price)
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "v-data-table__mobile-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__header",
                                    },
                                    [_vm._v("Total Cost")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__cell",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(_vm.summary.value)
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "v-data-table__mobile-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__header",
                                    },
                                    [_vm._v("Total Net")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__cell",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("currency")(_vm.summary.net)
                                        )
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                              _c(
                                "td",
                                { staticClass: "v-data-table__mobile-row" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__header",
                                    },
                                    [_vm._v("Ave Margin")]
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "v-data-table__mobile-row__cell",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          (
                                            (_vm.summary.net /
                                              _vm.summary.price) *
                                            100
                                          ).toFixed(2)
                                        ) + "%"
                                      ),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          )
                        : _c("tr", [
                            _c("th", { attrs: { colspan: "3" } }, [
                              _vm._v(" Total "),
                            ]),
                            _c("th", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumber")(_vm.summary.quantity)
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("th", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("formatNumber")(
                                      _vm.summary.weightAdj
                                    )
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("th", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("currency")(_vm.summary.price)
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("th"),
                            _c("th", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("currency")(_vm.summary.value)
                                  ) +
                                  " "
                              ),
                            ]),
                            _c("th"),
                            _c("th", [
                              _vm._v(
                                _vm._s(_vm._f("currency")(_vm.summary.net))
                              ),
                            ]),
                            _c("th", [
                              _vm._v(
                                _vm._s(
                                  (
                                    (_vm.summary.net / _vm.summary.price) *
                                    100
                                  ).toFixed(2)
                                ) + "%"
                              ),
                            ]),
                            _c("th", { attrs: { colspan: "2" } }),
                          ]),
                    ]
                  )
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }